import olXYZ from './../../node_modules/ol/source/XYZ.js';

class XYZ extends olXYZ {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

export default XYZ;